import { Component } from 'react';
import classNames from 'classnames';
import autoBind from 'react-autobind';

import { loadTrendingBarInfo } from '../../../services/dbServices/trendingBarServices';
import TopicItem from './TopicItem';
import WatchlistModal from '../../Modals/WatchlistModal';
import withComponentName from '../../../decorators/withComponentName';

import './styles.css';

export class TrendingTopics extends Component {
  constructor(props) {
    super(props);
    this.searchResultInterval = 0;
    this.state = {
      viewType: 'Detailed',
      period: 'hour1',
      topics: [],
      expandedTopic: 0,
      maxScore: 0,
      openModal: false,
      selectedTopic: {},
      loading: false,
    };
    autoBind(this);
  }

  componentDidMount() {
    const { refresh_rate: refreshEvery } = this.props;

    this.getTopics();
    if (refreshEvery !== 'never' && Number(refreshEvery)) {
      this.searchResultInterval = setInterval(this.getTopics, refreshEvery);
    }
    window.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  componentDidUpdate(prevProps) {
    const { refresh_rate: refreshEvery } = this.props;

    if (prevProps.refresh_rate !== refreshEvery) {
      clearInterval(this.searchResultInterval);
      if (refreshEvery !== 'never' && Number(refreshEvery)) {
        this.searchResultInterval = setInterval(this.getTopics, refreshEvery);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('visibilitychange', this.onVisibilityChange);
    clearInterval(this.searchResultInterval);
  }

  getTopics() {
    const { getTrendingTopics } = this.props;
    const { period } = this.state;

    this.setState({ loading: true });

    loadTrendingBarInfo(period, 'all')
      .then(({ data }) => {
        const topics = data.trending_topics;

        if (topics.length) this.getMaximumScore(topics);

        this.setState({
          topics,
          loading: false,
        });
        // send trending topics up for recommended stories service
        getTrendingTopics(topics);
      });
  }

  getMaximumScore(topics) {
    const max = topics.reduce((a, b) => (a.score > b.score ? a : b));

    this.setState({
      maxScore: max.score,
    });
  }

  updateExpandedTopic(topicID) {
    this.setState({
      expandedTopic: topicID,
    });
  }

  changePeriod(period) {
    const { piwikEnabled } = this.props;

    this.setState({
      period: period.value,
    }, () => {
      if (piwikEnabled) _paq.push(['trackEvent', 'Trending page', 'Trending period', period.title]);

      this.getTopics();
    });
  }

  toggleViewType(type) {
    const { piwikEnabled } = this.props;

    this.setState({
      viewType: type,
    }, () => {
      if (type === 'Basic' && piwikEnabled) _paq.push(['trackEvent', 'Trending page', 'Basic view']);
      if (type === 'Detailed' && piwikEnabled) _paq.push(['trackEvent', 'Trending page', 'Detailed view']);
    });
  }

  showWatchlistModal(topic) {
    const { openModal } = this.state;

    this.setState({
      openModal: !openModal,
      selectedTopic: topic,
    });
  }

  onVisibilityChange() {
    if (document.hidden) {
      clearInterval(this.searchResultInterval);
    } else {
      const { refresh_rate: refreshEvery } = this.props;

      if (refreshEvery !== 'never' && Number(refreshEvery)) {
        this.searchResultInterval = setInterval(this.getTopics, refreshEvery);
      }
    }
  }

  handleCloseModal() {
    this.setState({
      openModal: false,
    });
  }

  render() {
    const viewTypes = ['Basic', 'Detailed'];
    const periods = [
      { title: '15 mins', value: 'minutes15' },
      { title: '1 hour', value: 'hour1' },
      { title: '1 day', value: 'day1' },
    ];
    const {
      viewType,
      period,
      topics,
      selectedTopic,
      openModal,
      maxScore,
      expandedTopic,
      loading,
    } = this.state;
    const { user, piwikEnabled } = this.props;

    return (
      <div className="TrendingTopics">
        <div className="TrendingTopics__head">
          <span className="TrendingTopics__head--title">Trending Topics</span>

          <div className="TrendingTopics__head--tabs">
            {viewTypes.map((type) => (
              <span
                key={type}
                className={`${viewType === type ? 'active' : ''}`}
                onClick={() => this.toggleViewType(type)}
              >
                {type}
              </span>
            ))}
          </div>
        </div>

        <div className="TrendingTopics__period-tabs">
          {periods.map((periodItem) => (
            <span
              key={periodItem.title}
              className={classNames('TrendingTopics__period-tabs--tab', { active: period === periodItem.value })}
              onClick={() => this.changePeriod(periodItem)}
            >
              {periodItem.title}
            </span>
          ))}
        </div>

        {topics.map((topic, index) => (
          <TopicItem
            key={topic.id}
            id={index + 1}
            data={topic}
            user={user}
            maxScore={maxScore}
            basicView={viewType === 'Basic'}
            expandedTopic={expandedTopic}
            onExpand={this.updateExpandedTopic}
            onAddToWatchList={this.showWatchlistModal}
            piwikEnabled={piwikEnabled}
          />
        ))}

        {!topics.length && !loading && (
          <span className="TrendingTopics__no-topics">
            No trending topics at this moment
            <br />
            for the chosen time period
          </span>
        )}
        {openModal && (
          <WatchlistModal
            openModal={openModal}
            handleCloseModal={this.handleCloseModal}
            topic={selectedTopic}
          />
        )}
      </div>
    );
  }
}

export default withComponentName(TrendingTopics);
